import babelpolyfill from "babel-polyfill";
import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-default/index.css";
//import './assets/theme/theme-green/index.css'
import VueRouter from "vue-router";
import store from "./vuex/store";
import Vuex from "vuex";
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from "./routes";
import "font-awesome/css/font-awesome.min.css";
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(Vuex);
import Cookies from "js-cookie";
//NProgress.configure({ showSpinner: false });

const router = new VueRouter({
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  //NProgress.start();
  if (to.path == "/login") {
    Cookies.set("user_info", "", { path: "/", domain: "yongtengyc.com" });
    Cookies.set("user_info.sig", "", { path: "/", domain: "yongtengyc.com" });
  }
  let user;
  try {
    user = JSON.parse(decodeURI(Cookies.get("user_info")));
    store.dispatch("setUserInfo", user);
  } catch (e) {
    console.log("e", e);
  }

  if (~navigator.userAgent.indexOf("MicroMessenger")) {
    // if (!user && to.path != '/wechat-login') {
    //   next({ path: '/wechat-login' });
    // } else {
    //   next();
    // }
    next();
  } else {
    if (!user && to.path != "/login") {
      next({ path: "/login" });
    } else {
      next();
    }
  }
});

//router.afterEach(transition => {
//NProgress.done();
//});

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js